module.exports = __webpack_public_path__ + "media/attack.d102d3d1.mp3";